import BaseTransformer from "./base.transformer"
import PlanTransformer from "./plan.transformer"
export const baseUri = "/api/plan-prices"

function getName(months) {
  let options = {
    1: "monthly",
    12: "yearly"
  }
  return options[months] ?? ""
}

class PlanPriceTransformer extends BaseTransformer {
  static fetch(planPrice) {
    const uuid = this.transformUuid(planPrice)

    return this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      name: getName(planPrice.months),
      displayName: planPrice.displayName,
      months: planPrice.months,
      unitPrice: Number(planPrice.discountedPriceFloat || planPrice.unitPriceFloat || 0).toFixed(2),
      priceFloat: planPrice.priceFloat,
      price: Number(planPrice.priceFloat || 0).toFixed(2),
      discountedPriceFloat: planPrice.discountedPriceFloat ?? 0,
      discountPercentage: planPrice.discountPercentage
        ? Number(planPrice.discountPercentage || 0).toFixed(0)
        : null,
      renewDate: planPrice.renewDate,
      plan:
        typeof planPrice.plan === "string" ? planPrice.plan : PlanTransformer.fetch(planPrice.plan)
    })
  }
}

export const getBillingCycleName = getName

export default PlanPriceTransformer
